<template>
  <div class="">
    <sui-accordion :exclusive="false" fluid styled>
      <sui-accordion-title active>
        <sui-icon name="dropdown" />
        Productos
      </sui-accordion-title>
      <sui-accordion-content active>
        <div class="ui divided unstackable items">
          <ProductDetails
            v-for="product in cart.products"
            :key="product.attributeId"
            :product="product"
            :show-buttons="false"
            :isMatrix="isMatrix"
            :isWholesale="isWholesale"
          />
        </div>
      </sui-accordion-content>
      <sui-accordion-title active>
        <sui-icon name="dropdown" />
        Dirección y método de envio
      </sui-accordion-title>
      <sui-accordion-content active>
        <div class="ui basic segment">
          <div class="card">
            <div class="content">
              <div class="header">
                <h4>{{ `${customer.name} ${customer.lastName}` }}</h4>
              </div>
              <div class="description">
                {{ address.street }} <br />
                {{ address.neigh }}<br />
                {{ address.postalCode }}<br />
                {{ address.city }}, {{ address.state }}<br />
                {{ address.country }}
              </div>
            </div>
          </div>
        </div>
        <ShippingSelector
          @onSelected="onShippingSelected"
          @onSecured="secureShipping"
        />
      </sui-accordion-content>
      <sui-accordion-title active>
        <sui-icon name="dropdown" />
        Resumen final
      </sui-accordion-title>
      <sui-accordion-content active>
        <Summary :shipping="shipping" :isSecured="true" />
        <br />
        <div
          class="ui right floated teal button"
          :class="{ disabled: !isCompleted }"
          @click="submitOrder"
        >
          Ingresar Pedido
        </div>
        <br />
        <br />
      </sui-accordion-content>
    </sui-accordion>
  </div>
</template>

<script>
import VueNumericInput from 'vue-numeric-input';
import ProductDetails from '../product/ProductDetails';
import ShippingSelector from '../shipping/ShippingSelector';
import Summary from '../checkout/Summary';

export default {
  name: 'OrderConfirmationForm',
  data: function() {
    return {
      shipping: {
        price: 0
      },
      isSecured: true,
      isCompleted: false
    };
  },
  computed: {
    cart: function() {
      return this.$store.getters['cart/getCart'];
    },
    customer: function() {
      return this.$store.getters['auth/getCustomer'];
    },
    address: function() {
      if (this.customer.type === 'guest') {
        return this.customer.addresses[0];
      } else {
        const addressId = this.$store.getters['auth/getTargetAddress'];
        return this.customer.addresses.find(a => a._id === addressId);
      }
    },
    isMatrix: function() {
      return this.$store.getters['application/isMatrix'];
    },
    itemsForWholesale: function() {
      return this.$store.getters['application/getWholeSaleQty'];
    },
    isWholesaleEnabled: function() {
      return this.$store.getters['application/isWholesaleEnabled'];
    },
    totalItems: function() {
      return this.$store.getters['cart/totalItems'];
    },
    isWholesale: function() {
      if (this.isWholesaleEnabled) {
        return this.totalItems >= this.itemsForWholesale;
      } else {
        return false;
      }
    }
  },
  methods: {
    onShippingSelected: function(shipping) {
      this.shipping = shipping;
      this.isCompleted = true;
    },
    secureShipping: function(secured) {
      this.isSecured = secured;
    },
    submitOrder: async function() {
      if (this.isCompleted) {
        this.$emit('loading', true);
        console.log('Submiting order');
        const resp = await this.$store.dispatch('cart/checkout', {
          shippingId: this.shipping._id,
          secured: this.isSecured
        });

        this.$router.push({ name: 'Order', params: { id: resp._id } });
      } else {
        console.log('Show select shipping method');
      }
    }
  },
  components: {
    ProductDetails,
    ShippingSelector,
    Summary
  }
};
</script>

<style></style>
